import type { LeadScore } from 'types/entity'

/** `#DivScoreCard` from CreateLeadView — the lead-score breakdown panel. */
export function ScoreCard({ score }: { score: LeadScore }) {
  const pct = Math.max(0, Math.min(100, score.score))

  return (
    <div className="score-entity">
      <h5>{score.personName}</h5>
      <div className="company-name">{score.companyName}</div>

      <div className="score-meter" title={`Score ${pct} / 100`}>
        <span style={{ width: `${pct}%` }} />
      </div>

      {score.details.map((row) => (
        <p key={row.label}>
          <span>{row.label}</span>
          <span>{row.value}</span>
        </p>
      ))}
    </div>
  )
}
